


// export default function MediaPage() {
//   return (
//     <div className="w-full min-h-screen bg-gray-50 flex flex-col">

//       {/* Header */}
//       <header className="w-full bg-blue-700 text-white py-4 px-6 shadow">
//         <h1 className="text-xl font-semibold">Konn3ct Media Gallery</h1>
//       </header>

//       {/* Zoho Folder Embed */}
//       <div className="flex-1 w-full p-4">
//         <iframe
//           src="https://workdrive.zohoexternal.com/external/4p4mw2233e874b29c433a8e5abddc884e0ec3"
//           title="Konn3ct Media"
//           className="w-full h-[85vh] rounded-xl border border-gray-300 shadow"
//           allow="fullscreen"
//         ></iframe>
//       </div>

//       {/* Footer */}
//       <footer className="w-full bg-gray-800 text-white text-center py-4">
//         <p className="text-sm">© {new Date().getFullYear()} Konn3ct Media. All Rights Reserved.</p>
//       </footer>
//     </div>
//   );
// }



import React from "react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Footer from "../Header & Footer/kfooter";

const MediaPage = () => {
//   const [mediaList, setMediaList] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const folderId = "4p4mw2233e874b29c433a8e5abddc884e0ec3";

//   useEffect(() => {
//     const fetchMedia = async () => {
//       try {
//         const res = await fetch(
//           `https://workdrive.zoho.com/api/v1/public/files/${folderId}`
//         );

//         const data = await res.json();

//         if (data?.data) {
//           const files = data.data.map((item) => ({
//             id: item.id,
//             name: item.name,
//             type: item.mimeType,
//             url: item.previewUrl || item.downloadUrl,
//           }));

//           setMediaList(files);
//         }
//       } catch (error) {
//         console.log("Error loading media:", error);
//       }

//       setLoading(false);
//     };

//     fetchMedia();
//   }, []);

  return (
    <div className="flex flex-col min-h-screen text-gray-800 overflow-hidden pt-[64px] sm:pt-[80px] md:pt-[100px]">

      {/* HEADER */}
      <Konn3ctHeader />

      {/* MAIN CONTENT */}
      <div className="flex-1 max-w-7xl w-full mx-auto px-4 py-8">

        <h2 className="text-center text-2xl font-bold mb-6">
          Konn3ct Media
        </h2>

        {/* {loading && (
          <p className="text-center text-blue-600 mb-4">Loading media…</p>
        )} */}

        {/* IFRAME WRAPPER */}
        <div className="w-full rounded-xl shadow-lg border border-gray-300 overflow-hidden">

          <iframe
            src="https://workdrive.zoho.com/folder/4p4mw2233e874b29c433a8e5abddc884e0ec3"
            title="Konn3ct Media"
            className="
              w-full
              h-[70vh]
              md:h-[80vh]
              rounded-xl
            "
            allow="fullscreen"
          ></iframe>

        </div>
      </div>

      {/* FOOTER */}
      <Footer />

    </div>
  );
};

export default MediaPage;




// import React from "react";
// import mediaItems from "../Gallery/MediaItems"


// const MediaPage = ()  =>{
//   return (
//     <div className="min-h-screen flex flex-col bg-gray-50">
      
//       {/* HEADER */}
//       <header className="w-full bg-white shadow-sm py-4">
//         <div className="max-w-6xl mx-auto px-4 text-center">
//           <h1 className="text-xl font-semibold text-gray-800">Konn3ct Media</h1>
//         </div>
//       </header>

//       {/* CONTENT */}
//       <main className="flex-1 max-w-6xl mx-auto px-4 py-8">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//           {mediaItems.map((src, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition"
//             >
//               <img
//                 src={src}
//                 alt={`media-${index}`}
//                 className="w-full h-48 object-cover"
//               />
//             </div>
//           ))}
//         </div>
//       </main>

//       {/* FOOTER */}
//       <footer className="w-full bg-gray-900 text-white py-6 mt-10">
//         <div className="max-w-6xl mx-auto px-4 text-center text-sm">
//           © {new Date().getFullYear()} Konn3ct. All rights reserved.
//         </div>
//       </footer>
//     </div>
//   );
// }
// export default  MediaPage;
